import { render, staticRenderFns } from "./ProjectGuestsAddExisting.vue?vue&type=template&id=f080368a&scoped=true"
import script from "./ProjectGuestsAddExisting.vue?vue&type=script&lang=ts"
export * from "./ProjectGuestsAddExisting.vue?vue&type=script&lang=ts"
import style0 from "./ProjectGuestsAddExisting.vue?vue&type=style&index=0&id=f080368a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f080368a",
  null
  
)

export default component.exports